/*-----------------------------------------------------------------
- buttons translations
-----------------------------------------------------------------*/
export default {
    edit           : 'ویرایش',
    cancel         : 'انصراف',
    delete         : 'حذف',
    save_edit      : 'ذخیره تغییرات',
    change_password: 'تغییر رمز عبور',
    pay            : 'پرداخت',
    details        : 'جزئیات',
    visit          : 'مشاهده',
    back           : 'بازگشت',
    add_address    : 'آدرس جدید',
};
